import type { Brand } from '@axo/config/@types/Brand.types';
import { ConfigType } from '@axo/shared/data-access/types/consent';
import { MarketCountryCode } from '@axo/shared/types';

export const consentKeys = {
  root: () => ['consent'] as const,
  items: (country?: MarketCountryCode, customerID?: string) =>
    [...consentKeys.root(), 'items', country, customerID] as const,
  config: (
    country: MarketCountryCode,
    brandID: Brand,
    configType?: ConfigType
  ) => [...consentKeys.root(), 'config', country, brandID, configType] as const,
  user: (
    country: MarketCountryCode,
    customerID: string,
    configType: ConfigType
  ) =>
    [...consentKeys.root(), 'user', country, customerID, configType] as const,
};

export function parseConsentKey<T extends keyof typeof consentKeys>(
  queryKey: ReturnType<(typeof consentKeys)[T]>
) {
  const [, type, ...rest] = queryKey;

  switch (type) {
    case 'config': {
      const [country, brandID, configType] = rest;
      return {
        country,
        brandID: brandID as Brand,
        configType,
      };
    }

    default: {
      const [country, customerID, configType] = rest;
      return {
        country,
        customerID,
        configType,
      };
    }
  }
}
